import React from 'react';
import { useNavigate } from 'react-router-dom';

function Footer() {
  const navigate = useNavigate();

  return (
   <footer className="w-full border-t border-gray-100 px-4 sm:px-6 py-4 bg-white text-sm text-gray-600">
  <div className="flex flex-col md:flex-row justify-between items-center w-full gap-2 md:gap-0 text-center md:text-left">
    <div>© 2025 Coded Estate, All rights reserved.</div>
    <div className="flex gap-4">
      <button onClick={() => navigate('/rent/onboarding/privacy')} className="hover:text-gray-900">
        Privacy
      </button>
      <button onClick={() => navigate('/rent/onboarding/terms')} className="hover:text-gray-900">
        Terms
      </button>
    </div>
  </div>
</footer>

  );
}

export default Footer;
